module.exports = __webpack_public_path__ + "static/media/song.4da17f7d.svg";